/** Uses window.location.href */
export const getSearchParam = ({ paramName, searchParams }: { paramName: string; searchParams: URLSearchParams }) =>
    searchParams.get(`${paramName}`)
